module.exports = __webpack_public_path__ + "img/9788954623803.3eddf114.jpg";